<template>
  <b-modal
    ref="openSshKey"
    centered
    size="xl"
    title="OpenSSH Public Key"
    footer-bg-variant=""
    body-class="pb-0"
    hide-header
    @hidden="clearOpenSshKey">
    <template v-if="!openSshKeyEmpty">
      <b-alert
        variant="light-info"
        show
        class="mb-8">
        <p>
          Secure Shell (SSH) key authentication provides a more secure and convenient way to access remote servers compared to traditional password-based logins. By following these steps, you can configure SSH key authentication on a remote server:
        </p>
        <ol class="mb-4 pl-6">
          <li class="mb-4">
            Add the public key you received to the <code>./.ssh/authorized_keys</code> file on the remote server, or use the following command:
            <p class="mb-1">
              <code>ssh-copy-id -i ./id_rsa.pub username@remote_host</code>
            </p>
            Where <code>id_rsa.pub</code> is your public key.
          </li>
          <li class="mb-4">
            <p>Authenticate to the remote server in order to edit the <code>sshd_config</code> file.</p>
            <p class="mb-0">
              Locate the file at <code>/etc/ssh/sshd_config</code> (this location may vary depending on your operating system), and modify the following parameters to these values: <code>PubkeyAuthentication yes</code>.
            </p>
          </li>
          <li>
            After making these changes, restart the SSH service: <code>service sshd restart</code>.
          </li>
        </ol>
        <p class="mb-0">
          Make sure to replace <code>username</code> and <code>remote_host</code> with your actual username and the code or IP address of the remote server.
        </p>
      </b-alert>
      <b-form-group
        id="openSshKey"
        label="OpenSSH Public Key"
        label-for="openSshKey"
        class="w-100 mb-0">
        <b-form-textarea
          v-model="openSshKey"
          id="openSshKey-input"
          rows="7"
          readonly
          no-resize />
      </b-form-group>
    </template>
    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('openSshKey')">
          Close
        </b-button>
        <b-button
          id="copyOpenSshKeyBtn"
          v-wave
          variant="primary"
          size="md"
          class="ml-auto"
          data-clipboard-target="#openSshKey-input">
          <i class="fa fa-copy fa-sm mr-1"></i>
          <span>Copy to Clipboard</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Clipboard from 'clipboard'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showToast, showModal, hideModal } from '@/core/utils'
import { CLEAR_OPENSSH_KEY } from '@/core/services/store/servers.module'

export default {
  name: 'ModalOpenSshKey',
  data() {
    return {
      clipboard: null,

      showToast,
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'openSshKey',
      'openSshKeyEmpty',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => {
      this.showModal(type)
    })

    this.initClipboard()
  },
  destroyed() {
    eventBus.$off('openModal')

    this.destroyClipboard()
  },
  methods: {
    initClipboard() {
      this.clipboard = new Clipboard('#copyOpenSshKeyBtn')

      this.clipboard.on('success', () => {
        this.showToast('Copied to clipboard!', 'info')
      })
      this.clipboard.on('error', () => {
        this.showToast('Failed to copy to clipboard!', 'danger')
      })
    },

    destroyClipboard() {
      if (this.clipboard) {
        this.clipboard.destroy()
        this.clipboard = null
      }
    },

    clearOpenSshKey() {
      this.$store.commit(CLEAR_OPENSSH_KEY)
    },
  }
}
</script>
